import { defineStore } from 'pinia'
import { ref } from 'vue'

// Shared by useStripePayment and resetSetupIntent so an identity change can drop the SetupIntent without a component mounted.
export const useStripeSetupIntentStore = defineStore('stripeSetupIntent', () => {
  const setupIntentId = ref<string>()
  const stripeSecret = ref<string>()
  const fetchPromise = ref<Promise<void> | null>(null)

  return { setupIntentId, stripeSecret, fetchPromise }
})
